import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, ControlLabel, FormControl, Checkbox, Panel, Grid, Row, Col, Radio, Alert, Tabs, Tab, Collapse } from 'react-bootstrap';
import { HandleMessage } from '../../HandleMessage';

export class SchematicMapDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let schematicMapConfiguration = {
            show: false,
            id: props.selectedData || null,

            // Simple Configurations
            // Transit Map Parameters
            lineWidth: 30,
            lineSpacing: 20,
            outlineWidth: 2,
            backgroundType: 0,
            addLinesDivisions: false,
            noDeg2Labels: true,
            renderDirectionMarkers: true,
            reduceLabelSizeInCollisions: false,
            directionMarkerType: 0,

            // Advanced Configurations
            // Loom Parameters
            isToUntangle: false,
            isToPrune: false,
            optimizationMethod: 10,
            sameSegmentCrossPenalization: 4,
            diffSegmentCrossPenalization: 1,
            stationCrossPenSameSegment: 12,
            stationCrossPenDifferentSegment: 3,
            separationsPenalty: 3,
            inStationsSeparationPenalty: 9,

            // Octi Parameters
            optimizationMode: 0,
            gridSize: 100,
            graphType: 2,
            retryOnError: false,
            skipOnError: false,
            hananIterations: 1,
            maxLocalSearchIterations: 100,
            noDeg2Heur: false,
            geographicPenalization: 1.5,
            maxGridDistance: 3,
            restrictLocalSearch: false,
            edgeOrder: 1,
            densityPenalization: 10,
            verticalPenalization: 0,
            horizontalPenalization: 0,
            diagonalPenalization: 0.5,
            penalize180deg: 0,
            penalize135deg: 1,
            penalize90deg: 1.5,
            penalize45deg: 2,
            nodeMovementPenalty: 0.5,

            // Misc
            isToComputeShapes: true,
            skipOcti: false,
            isGridInPercentage: false,
            aggregateLinesByColor: false,
            aggregateLinesByOrientation: false
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            schematicMapConfiguration = Object.assign(schematicMapConfiguration, parsedConfig);
        } catch (error) { }

        this.state = {
            selectedData: props.selectedData,
            table: {
                data: [],
                loading: true,
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
            },
            form: {
                show: schematicMapConfiguration.show,
                id: schematicMapConfiguration.id,
                lineWidth: schematicMapConfiguration.lineWidth,
                lineSpacing: schematicMapConfiguration.lineSpacing,
                outlineWidth: schematicMapConfiguration.outlineWidth,
                backgroundType: schematicMapConfiguration.backgroundType,
                addLinesDivisions: schematicMapConfiguration.addLinesDivisions,
                noDeg2Labels: schematicMapConfiguration.noDeg2Labels,
                renderDirectionMarkers: schematicMapConfiguration.renderDirectionMarkers,
                reduceLabelSizeInCollisions: schematicMapConfiguration.reduceLabelSizeInCollisions,
                directionMarkerType: schematicMapConfiguration.directionMarkerType,
                isToUntangle: schematicMapConfiguration.isToUntangle,
                isToPrune: schematicMapConfiguration.isToPrune,
                optimizationMethod: schematicMapConfiguration.optimizationMethod,
                sameSegmentCrossPenalization: schematicMapConfiguration.sameSegmentCrossPenalization,
                diffSegmentCrossPenalization: schematicMapConfiguration.diffSegmentCrossPenalization,
                stationCrossPenSameSegment: schematicMapConfiguration.stationCrossPenSameSegment,
                stationCrossPenDifferentSegment: schematicMapConfiguration.stationCrossPenDifferentSegment,
                separationsPenalty: schematicMapConfiguration.separationsPenalty,
                inStationsSeparationPenalty: schematicMapConfiguration.inStationsSeparationPenalty,
                optimizationMode: schematicMapConfiguration.optimizationMode,
                gridSize: schematicMapConfiguration.gridSize,
                graphType: schematicMapConfiguration.graphType,
                retryOnError: schematicMapConfiguration.retryOnError,
                skipOnError: schematicMapConfiguration.skipOnError,
                hananIterations: schematicMapConfiguration.hananIterations,
                maxLocalSearchIterations: schematicMapConfiguration.maxLocalSearchIterations,
                noDeg2Heur: schematicMapConfiguration.noDeg2Heur,
                geographicPenalization: schematicMapConfiguration.geographicPenalization,
                maxGridDistance: schematicMapConfiguration.maxGridDistance,
                restrictLocalSearch: schematicMapConfiguration.restrictLocalSearch,
                edgeOrder: schematicMapConfiguration.edgeOrder,
                densityPenalization: schematicMapConfiguration.densityPenalization,
                verticalPenalization: schematicMapConfiguration.verticalPenalization,
                horizontalPenalization: schematicMapConfiguration.horizontalPenalization,
                diagonalPenalization: schematicMapConfiguration.diagonalPenalization,
                penalize180deg: schematicMapConfiguration.penalize180deg,
                penalize135deg: schematicMapConfiguration.penalize135deg,
                penalize90deg: schematicMapConfiguration.penalize90deg,
                penalize45deg: schematicMapConfiguration.penalize45deg,
                nodeMovementPenalty: schematicMapConfiguration.nodeMovementPenalty,
                skipOcti: schematicMapConfiguration.skipOcti,
                isToComputeShapes: schematicMapConfiguration.isToComputeShapes,
                isGridInPercentage: schematicMapConfiguration.isGridInPercentage,
                aggregateLinesByColor: schematicMapConfiguration.aggregateLinesByColor,
                aggregateLinesByOrientation: schematicMapConfiguration.aggregateLinesByOrientation,
            },
            actions: {
                isLoading: true,
            },
            collapsedSections: {
                layoutOptions: false,
                anglePenalties: true,
                crossingPenalties: true,
                edgePenalties: true,
                optimizationOptions: true,
                gridOptions: true
            }
        };
    }

    // -----------------------

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];
        if(target === "aggregateLinesByColor" && !form[target]) {
            form.aggregateLinesByOrientation = false;
        }

        this.setState({
            form: form
        });
    }

    toggleSection(section) {
        this.setState(prevState => ({
            collapsedSections: {
                ...prevState.collapsedSections,
                [section]: !prevState.collapsedSections[section]
            }
        }));
    };

    onFinishSelectData() {
        const { form } = this.state;

        if (form.penalize180deg > form.penalize135deg || form.penalize135deg > form.penalize90deg || form.penalize90deg > form.penalize45deg) {
            this.setState({
                message: {
                    show: true,
                    title: "Configuração Inválida",
                    message: "A penalização de 180° deve ser menor ou igual à de 135°, e esta deve ser menor ou igual à de 90°, e esta deve ser menor ou igual à de 45°.",
                    style: "danger",
                    icon: "glyphicon glyphicon-exclamation-sign"
                }
            });

            return;
        }

        const configuration = {
            lineWidth: form.lineWidth,
            lineSpacing: form.lineSpacing,
            outlineWidth: form.outlineWidth,
            backgroundType: form.backgroundType,
            addLinesDivisions: form.addLinesDivisions,
            noDeg2Labels: form.noDeg2Labels,
            renderDirectionMarkers: form.renderDirectionMarkers,
            reduceLabelSizeInCollisions: form.reduceLabelSizeInCollisions,
            directionMarkerType: form.directionMarkerType,
            isToUntangle: form.isToUntangle,
            isToPrune: form.isToPrune,
            optimizationMethod: form.optimizationMethod,
            sameSegmentCrossPenalization: form.sameSegmentCrossPenalization,
            diffSegmentCrossPenalization: form.diffSegmentCrossPenalization,
            stationCrossPenSameSegment: form.stationCrossPenSameSegment,
            stationCrossPenDifferentSegment: form.stationCrossPenDifferentSegment,
            separationsPenalty: form.separationsPenalty,
            inStationsSeparationPenalty: form.inStationsSeparationPenalty,
            optimizationMode: form.optimizationMode,
            gridSize: form.gridSize,
            graphType: form.graphType,
            retryOnError: form.retryOnError,
            skipOnError: form.skipOnError,
            hananIterations: form.hananIterations,
            maxLocalSearchIterations: form.maxLocalSearchIterations,
            noDeg2Heur: form.noDeg2Heur,
            geographicPenalization: form.geographicPenalization,
            maxGridDistance: form.maxGridDistance,
            restrictLocalSearch: form.restrictLocalSearch,
            edgeOrder: form.edgeOrder,
            densityPenalization: form.densityPenalization,
            verticalPenalization: form.verticalPenalization,
            horizontalPenalization: form.horizontalPenalization,
            diagonalPenalization: form.diagonalPenalization,
            penalize180deg: form.penalize180deg,
            penalize135deg: form.penalize135deg,
            penalize90deg: form.penalize90deg,
            penalize45deg: form.penalize45deg,
            nodeMovementPenalty: form.nodeMovementPenalty,
            skipOcti: form.skipOcti,
            isToComputeShapes: form.isToComputeShapes,
            isGridInPercentage: form.isGridInPercentage,
            aggregateLinesByColor: form.aggregateLinesByColor,
            aggregateLinesByOrientation: form.aggregateLinesByOrientation
        };

        // Trigger save actions
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                show: false,
                id: null,
                lineWidth: 30,
                lineSpacing: 20,
                outlineWidth: 2,
                backgroundType: 0,
                addLinesDivisions: false,
                noDeg2Labels: true,
                renderDirectionMarkers: true,
                reduceLabelSizeInCollisions: false,
                directionMarkerType: 0,
                isToUntangle: false,
                isToPrune: false,
                optimizationMethod: 10,
                sameSegmentCrossPenalization: 4,
                diffSegmentCrossPenalization: 1,
                stationCrossPenSameSegment: 12,
                stationCrossPenDifferentSegment: 3,
                separationsPenalty: 3,
                inStationsSeparationPenalty: 9,
                optimizationMode: 0,
                gridSize: 100,
                graphType: 2,
                retryOnError: false,
                skipOnError: false,
                hananIterations: 1,
                maxLocalSearchIterations: 100,
                noDeg2Heur: false,
                geographicPenalization: 1.5,
                maxGridDistance: 3,
                restrictLocalSearch: false,
                edgeOrder: 1,
                densityPenalization: 10,
                verticalPenalization: 0,
                horizontalPenalization: 0,
                diagonalPenalization: 0.5,
                penalize180deg: 0,
                penalize135deg: 1.5,
                penalize90deg: 0,
                penalize45deg: 0,
                nodeMovementPenalty: 0.5,
                skipOcti: false,
                isToComputeShapes: true,
                isGridInPercentage: false,
                aggregateLinesByColor: false,
                aggregateLinesByOrientation: false
            },
            styles: {},
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    handleFormFieldChange(field) {
        return (e) => {
            const value = e.target.type === "number" ? Number(e.target.value) : e.target.value;
            const updatedForm = this.state.form;
            updatedForm[field] = value;
            this.setState({ form: updatedForm });
        };
    }

    onChangeRadioValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    renderNumberInput(label, placeholder, value, controlId, min, max, onChange, isDisabled = false) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="number"
                    min={min}
                    max={max}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={isDisabled}
                />
            </FormGroup>
        );
    }

    renderCollapsibleSection(title, section, content) {
        const { collapsedSections } = this.state;
        return (
            <div className="schematicmap-collapsible-container">
                <div
                    onClick={() => this.toggleSection(section)}
                    className="schematicmap-collapsible-header"
                >
                    <span>{title}</span>
                    <span className={`schematicmap-dropdown-span ${collapsedSections[section] ? 'open' : 'closed'}`}>▶</span>
                </div>
                <Collapse in={!collapsedSections[section]}>
                    <div className="schematicmap-collapsible-content">
                        {content}
                    </div>
                </Collapse>
            </div>
        );
    }

    renderLayoutOptions() {
        const { form } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Col md={6}>
                        <FormGroup controlId="formgraphType">
                            <ControlLabel>Apresentação do Mapa Esquemático</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={form.graphType}
                                onChange={this.handleFormFieldChange("graphType")}>
                                <option value={1}>Ortolinear</option>
                                <option value={2}>Octilinear</option>
                                <option value={3}>Ortoradial</option>
                                <option value={4}>Quadtree</option>
                                <option value={5}>Octihanan</option>
                            </FormControl>
                            <p className="help-block">
                                Define o tipo de apresentação do mapa esquemático.
                            </p>
                        </FormGroup>
                        {this.renderNumberInput(
                            "Precisão Geográfica",
                            "0",
                            form.geographicPenalization,
                            "formgeographicPenalization",
                            0,
                            5,
                            this.handleFormFieldChange("geographicPenalization")
                        )}
                        <p className="help-block">
                            Quanto maior o valor, mais o mapa respeitará a posição geográfica real.
                        </p>
                    </Col>
                    <Col md={6}>
                        {this.renderNumberInput(
                            "Penalização de Movimento de Nós",
                            "0",
                            form.nodeMovementPenalty,
                            "formnodeMovementPenalty",
                            0,
                            10,
                            this.handleFormFieldChange("nodeMovementPenalty")
                        )}
                        <p className="help-block">
                            Penalização aplicada ao movimento de nós no mapa.
                        </p>

                        {this.renderNumberInput(
                            "Penalização de Densidade",
                            "0",
                            form.densityPenalization,
                            "formdensityPenalization",
                            0,
                            100,
                            this.handleFormFieldChange("densityPenalization")
                        )}
                        <p className="help-block">
                            Penalização para áreas densas do mapa.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Checkbox
                                checked={form.isToUntangle}
                                onChange={() => this.onChangeCheckboxValue("isToUntangle")}
                            >
                                Desativar regras de untangle
                            </Checkbox>
                            <p className="help-block">
                                Não aplica regras de untangle ao mapa.
                            </p>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Checkbox
                                checked={form.isToPrune}
                                onChange={() => this.onChangeCheckboxValue("isToPrune")}
                            >
                                Desativar regras de prune
                            </Checkbox>
                            <p className="help-block">
                                Não aplica regras de prune ao mapa.
                            </p>
                        </FormGroup>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderAnglePenalties() {
        const { form } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Col md={3}>
                        {this.renderNumberInput(
                            "Ângulo 180°",
                            "0",
                            form.penalize180deg,
                            "formpenalize180deg",
                            0,
                            500,
                            this.handleFormFieldChange("penalize180deg")
                        )}
                        <p className="help-block">Penalização para curvas de 180°.</p>
                    </Col>
                    <Col md={3}>
                        {this.renderNumberInput(
                            "Ângulo 135°",
                            "0",
                            form.penalize135deg,
                            "formpenalize135deg",
                            0,
                            500,
                            this.handleFormFieldChange("penalize135deg")
                        )}
                        <p className="help-block">Penalização para ângulos de 135°.</p>
                    </Col>

                    <Col md={3}>
                        {this.renderNumberInput(
                            "Ângulo 90°",
                            "0",
                            form.penalize90deg,
                            "formpenalize90deg",
                            0,
                            500,
                            this.handleFormFieldChange("penalize90deg")
                        )}
                        <p className="help-block">Penalização para ângulos de 90°.</p>
                    </Col>

                    <Col md={3}>
                        {this.renderNumberInput(
                            "Ângulo 45°",
                            "0",
                            form.penalize45deg,
                            "formpenalize45deg",
                            0,
                            500,
                            this.handleFormFieldChange("penalize45deg")
                        )}
                        <p className="help-block">Penalização para ângulos de 45°.</p>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderCrossingPenalties() {
        const { form } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Col md={6}>
                        {this.renderNumberInput(
                            "Cruzamentos no Mesmo Segmento",
                            "0",
                            form.sameSegmentCrossPenalization,
                            "formsameSegmentCrossPenalization",
                            0,
                            100,
                            this.handleFormFieldChange("sameSegmentCrossPenalization")
                        )}
                        <p className="help-block">Penalização para cruzamentos no mesmo segmento.</p>

                        {this.renderNumberInput(
                            "Cruzamentos em Segmentos Diferentes",
                            "0",
                            form.diffSegmentCrossPenalization,
                            "formdiffSegmentCrossPenalization",
                            0,
                            100,
                            this.handleFormFieldChange("diffSegmentCrossPenalization")
                        )}
                        <p className="help-block">Penalização para cruzamentos em segmentos diferentes.</p>

                        {this.renderNumberInput(
                            "Separações",
                            "0",
                            form.separationsPenalty,
                            "formseparationsPenalty",
                            0,
                            100,
                            this.handleFormFieldChange("separationsPenalty")
                        )}
                        <p className="help-block">Penalização para separações entre linhas.</p>
                    </Col>

                    <Col md={6}>
                        {this.renderNumberInput(
                            "Cruzamentos em Estações (Mesmo Segmento)",
                            "0",
                            form.stationCrossPenSameSegment,
                            "formstationCrossPenSameSegment",
                            0,
                            100,
                            this.handleFormFieldChange("stationCrossPenSameSegment")
                        )}
                        <p className="help-block">Penalização para cruzamentos em estações no mesmo segmento.</p>

                        {this.renderNumberInput(
                            "Cruzamentos em Estações (Segmento Diferente)",
                            "0",
                            form.stationCrossPenDifferentSegment,
                            "formstationCrossPenDifferentSegment",
                            0,
                            100,
                            this.handleFormFieldChange("stationCrossPenDifferentSegment")
                        )}
                        <p className="help-block">Penalização para cruzamentos em estações em segmentos diferentes.</p>

                        {this.renderNumberInput(
                            "Separações em Estações",
                            "0",
                            form.inStationsSeparationPenalty,
                            "forminStationsSeparationPenalty",
                            0,
                            100,
                            this.handleFormFieldChange("inStationsSeparationPenalty")
                        )}
                        <p className="help-block">Penalização para separações em estações.</p>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderEdgePenalties() {
        const { form } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Col md={4}>
                        {this.renderNumberInput(
                            "Arestas Verticais",
                            "0",
                            form.verticalPenalization,
                            "formverticalPenalization",
                            0,
                            100,
                            this.handleFormFieldChange("verticalPenalization")
                        )}
                        <p className="help-block">Penalização para arestas verticais.</p>
                    </Col>

                    <Col md={4}>
                        {this.renderNumberInput(
                            "Arestas Horizontais",
                            "0",
                            form.horizontalPenalization,
                            "formhorizontalPenalization",
                            0,
                            100,
                            this.handleFormFieldChange("horizontalPenalization")
                        )}
                        <p className="help-block">Penalização para arestas horizontais.</p>
                    </Col>

                    <Col md={4}>
                        {this.renderNumberInput(
                            "Arestas Diagonais",
                            "0",
                            form.diagonalPenalization,
                            "formdiagonalPenalization",
                            0,
                            100,
                            this.handleFormFieldChange("diagonalPenalization")
                        )}
                        <p className="help-block">Penalização para arestas diagonais.</p>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderOptimizationOptions() {
        const { form } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Col md={6}>
                        <FormGroup controlId="formoptimizationMethod">
                            <ControlLabel>Método de Otimização</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={form.optimizationMethod}
                                onChange={this.handleFormFieldChange("optimizationMethod")}
                            >
                                <option value={0}>ILP Naive</option>
                                <option value={1}>ILP</option>
                                <option value={2}>Comb</option>
                                <option value={3}>Comb No ILP</option>
                                <option value={4}>Exhaust</option>
                                <option value={5}>Hill Climbing</option>
                                <option value={6}>Hill Climbing Random</option>
                                <option value={7}>Annealing</option>
                                <option value={8}>Annealing Random</option>
                                <option value={9}>Greedy</option>
                                <option value={10}>Greedy Lookahead</option>
                                <option value={11}>Null</option>
                            </FormControl>
                            <p className="help-block">Método de otimização a utilizar.</p>
                        </FormGroup>

                        <FormGroup controlId="formoptimizationMode">
                            <ControlLabel>Modo de Otimização</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={form.optimizationMode}
                                onChange={this.handleFormFieldChange("optimizationMode")}
                            >
                                <option value={0}>Heurístico</option>
                                <option value={1}>ILP</option>
                            </FormControl>
                            <p className="help-block">Modo de otimização: heurístico ou ILP.</p>
                        </FormGroup>

                        <FormGroup controlId="formEdgeOrder">
                            <ControlLabel>Ordenação de Arestas</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={form.edgeOrder}
                                onChange={this.handleFormFieldChange("edgeOrder")}
                            >
                                <option value={0}>Todas</option>
                                <option value={1}>Por número de linhas</option>
                                <option value={2}>Por comprimento — arestas mais longas têm prioridade</option>
                                <option value={3}>Por conectividade — arestas com mais vizinhos têm prioridade</option>
                                <option value={4}>Por densidade de linhas — arestas com mais linhas têm prioridade</option>
                                <option value={5}>Por crescimento de conectividade — arestas que permitem alcançar mais nós iterativamente têm prioridade</option>
                                <option value={6}>Por crescimento de linhas — arestas que permitem alcançar mais linhas iterativamente têm prioridade</option>
                            </FormControl> {/* TODO: Change the text */}
                            <p className="help-block">Método de ordenação inicial das arestas.</p>
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        {this.renderNumberInput(
                            "Iterações Hanan",
                            "0",
                            form.hananIterations,
                            "formhananIterations",
                            1,
                            100,
                            this.handleFormFieldChange("hananIterations")
                        )}
                        <p className="help-block">Número de iterações do grid Hanan.</p>

                        {this.renderNumberInput(
                            "Máximo de Iterações (Busca Local)",
                            "0",
                            form.maxLocalSearchIterations,
                            "formmaxLocalSearchIterations",
                            1,
                            1000,
                            this.handleFormFieldChange("maxLocalSearchIterations")
                        )}
                        <p className="help-block">Número máximo de iterações para busca local.</p>

                        <FormGroup>
                            <Checkbox
                                checked={form.noDeg2Heur}
                                onChange={() => this.onChangeCheckboxValue("noDeg2Heur")}
                            >
                                Desativar heurística de grau 2
                            </Checkbox>
                            <p className="help-block">
                                Desativa a contração de nós de grau 2.
                            </p>
                        </FormGroup>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderGridOptions() {
        const { form } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Col md={6}>
                        {this.renderNumberInput(
                            "Tamanho da Grelha",
                            "0",
                            form.gridSize,
                            "formGridSize",
                            1,
                            100,
                            this.handleFormFieldChange("gridSize")
                        )}
                        <FormGroup style={{ marginTop: "-10px" }}>
                            <Checkbox
                                checked={form.isGridInPercentage}
                                onChange={() => this.onChangeCheckboxValue("isGridInPercentage")}
                            >
                                Usar tamanho em percentagem
                            </Checkbox>
                        </FormGroup>
                        <p className="help-block">Tamanho das células da grelha (ex: 100).</p>

                        {this.renderNumberInput(
                            "Distância Máxima da Grelha",
                            "0",
                            form.maxGridDistance,
                            "formmaxGridDistance",
                            1,
                            100,
                            this.handleFormFieldChange("maxGridDistance")
                        )}
                        <p className="help-block">Distância máxima da grelha para candidatos de estação.</p>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Checkbox
                                checked={form.restrictLocalSearch}
                                onChange={() => this.onChangeCheckboxValue("restrictLocalSearch")}
                            >
                                Limitar busca local à distância máxima da grelha
                            </Checkbox>
                            <p className="help-block">
                                Restringe a busca local à distância máxima da grelha.
                            </p>
                        </FormGroup>

                        <FormGroup>
                            <Checkbox
                                checked={form.retryOnError}
                                onChange={() => this.onChangeCheckboxValue("retryOnError")}
                            >
                                Diminuir progressivamente a grelha em caso de erro
                            </Checkbox>
                            <p className="help-block">
                                Tenta novamente com 85% do tamanho da grelha (30 vezes).
                            </p>
                        </FormGroup>

                        <FormGroup>
                            <Checkbox
                                checked={form.skipOnError}
                                onChange={() => this.onChangeCheckboxValue("skipOnError")}
                            >
                                Ignorar em caso de erro
                            </Checkbox>
                            <p className="help-block">
                                Mantém o grafo gerado em caso de erro
                            </p>
                        </FormGroup>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderSimpleConfigurations() {
        const { form } = this.state;

        return (
            <div>
                <Panel bsStyle="default">
                    <Panel.Heading>
                        <h4 className="schematicmap-panel-heading">Aparência do Mapa</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <Grid fluid>
                            <Row>
                                <Col md={6}>
                                    {this.renderNumberInput(
                                        "Largura das Linhas",
                                        "0",
                                        form.lineWidth,
                                        "formLineWidthText",
                                        1,
                                        9999,
                                        this.handleFormFieldChange("lineWidth")
                                    )}
                                    <p className="help-block">Define a espessura das linhas no mapa.</p>

                                    {this.renderNumberInput(
                                        "Largura do Contorno das Linhas",
                                        "0",
                                        form.outlineWidth,
                                        "formLineBorderWidthText",
                                        1,
                                        9999,
                                        this.handleFormFieldChange("outlineWidth")
                                    )}
                                    <p className="help-block">Espessura do contorno das linhas.</p>

                                    {this.renderNumberInput(
                                        "Espaçamento das Linhas",
                                        "0",
                                        form.lineSpacing,
                                        "formLineSpacingText",
                                        1,
                                        9999,
                                        this.handleFormFieldChange("lineSpacing")
                                    )}
                                    <p className="help-block">Define a distância entre as linhas.</p>
                                </Col>

                                <Col md={6}>
                                    <FormGroup>
                                        <ControlLabel>Definir fundo do mapa</ControlLabel>
                                        <div className="schematicmap-radio-group">
                                            <Radio
                                                name="backgroundType"
                                                checked={form.backgroundType === 0}
                                                onChange={() => this.onChangeRadioValue(0, "backgroundType")}
                                            >
                                                Nenhum
                                            </Radio>
                                            <Radio
                                                name="backgroundType"
                                                checked={form.backgroundType === 1}
                                                onChange={() => this.onChangeRadioValue(1, "backgroundType")}
                                            >
                                                Esquemático
                                            </Radio>
                                            <Radio
                                                name="backgroundType"
                                                checked={form.backgroundType === 2}
                                                onChange={() => this.onChangeRadioValue(2, "backgroundType")}
                                            >
                                                Geográfico
                                            </Radio>
                                        </div>
                                        <p className="help-block">
                                            Define o tipo de fundo para o mapa esquemático.
                                        </p>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.skipOcti}
                                            onChange={() => this.onChangeCheckboxValue("skipOcti")}
                                        >
                                            Gerar mapa sem optimizações (Mapa Geográfico)
                                        </Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.isToComputeShapes}
                                            onChange={() => this.onChangeCheckboxValue("isToComputeShapes")}
                                        >
                                            Gerar mapa com shapes
                                        </Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.aggregateLinesByColor}
                                            onChange={() => this.onChangeCheckboxValue("aggregateLinesByColor")}
                                        >
                                            Agregar linhas por cor
                                        </Checkbox>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.aggregateLinesByOrientation}
                                            onChange={() => this.onChangeCheckboxValue("aggregateLinesByOrientation")}
                                            disabled={!form.aggregateLinesByColor}
                                        >
                                            Agregar linhas por direção
                                        </Checkbox>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Grid>
                    </Panel.Body>
                </Panel>

                <Panel bsStyle="default">
                    <Panel.Heading>
                        <h4 className="schematicmap-panel-heading">Legendas e Marcadores</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <Grid fluid>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.noDeg2Labels}
                                            onChange={() => this.onChangeCheckboxValue("noDeg2Labels")}
                                        >
                                            Ocultar as legendas de estações de 2º grau
                                        </Checkbox>
                                        <p className="help-block">
                                            Define se devem ser apresentadas legendas para as paragens de 2º grau.
                                        </p>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.reduceLabelSizeInCollisions}
                                            onChange={() => this.onChangeCheckboxValue("reduceLabelSizeInCollisions")}
                                        >
                                            Reduzir o tamanho das legendas em colisões
                                        </Checkbox>
                                        <p className="help-block">
                                            Diminui automaticamente o tamanho do texto quando há sobreposição entre legendas.
                                        </p>
                                    </FormGroup>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.addLinesDivisions}
                                            onChange={() => this.onChangeCheckboxValue("addLinesDivisions")}
                                        >
                                            Adicionar divisões entre legendas
                                        </Checkbox>
                                        <p className="help-block">
                                            Aumenta o espaçamento entre legendas e adiciona o caracter '|' entre elas.
                                        </p>
                                    </FormGroup>
                                </Col>

                                <Col md={6}>
                                    <FormGroup>
                                        <Checkbox
                                            checked={form.renderDirectionMarkers}
                                            onChange={() => this.onChangeCheckboxValue("renderDirectionMarkers")}
                                        >
                                            Mostrar marcadores de direção
                                        </Checkbox>
                                        <p className="help-block">
                                            Mostra marcadores para linhas com apenas um sentido.
                                        </p>
                                    </FormGroup>
                                    <FormGroup controlId="formDirectionMarkerType">
                                        <ControlLabel>Apresentação do marcador de direção</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            disabled={!form.renderDirectionMarkers}
                                            value={form.directionMarkerType}
                                            onChange={this.handleFormFieldChange("directionMarkerType")}
                                        >
                                            <option value={0}>Triangular</option>
                                            <option value={1}>Seta</option>
                                        </FormControl>
                                        <p className="help-block">
                                            Define o tipo de apresentação do marcador de direção.
                                        </p>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Grid>
                    </Panel.Body>
                </Panel>
            </div>
        );
    }

    renderAdvancedConfigurations() {
        return (
            <div>
                <Alert bsStyle="warning" className="schematicmap-warning-alert">
                    <strong>Atenção:</strong> estas configurações são destinadas a utilizadores avançados.<br />
                    Alterações incorretas podem comprometer o processo de geração e resultar na ausência de um mapa final.<br />
                    Proceda apenas se compreender plenamente o impacto de cada parâmetro.
                </Alert>

                {this.renderCollapsibleSection(
                    "Opções de Layout e Apresentação",
                    "layoutOptions",
                    this.renderLayoutOptions()
                )}

                {this.renderCollapsibleSection(
                    "Penalizações de Ângulo",
                    "anglePenalties",
                    this.renderAnglePenalties()
                )}

                {this.renderCollapsibleSection(
                    "Penalizações de Cruzamentos e Separações",
                    "crossingPenalties",
                    this.renderCrossingPenalties()
                )}

                {this.renderCollapsibleSection(
                    "Penalizações de Arestas",
                    "edgePenalties",
                    this.renderEdgePenalties()
                )}

                {this.renderCollapsibleSection(
                    "Opções de Otimização",
                    "optimizationOptions",
                    this.renderOptimizationOptions()
                )}

                {this.renderCollapsibleSection(
                    "Opções de Grid e Tratamento de Erros",
                    "gridOptions",
                    this.renderGridOptions()
                )}
            </div>
        );
    }

    render() {
        const { message } = this.state;

        return (
            <div className="config-form">
                <Tabs defaultActiveKey={1} id="config-tabs" animation={false}>
                    <Tab eventKey={1} title="Configurações Simples">
                        <div className="schematicmap-tab-content">
                            {this.renderSimpleConfigurations()}
                        </div>
                    </Tab>

                    <Tab eventKey={2} title="Configurações Avançadas">
                        <div className="schematicmap-tab-content">
                            {this.renderAdvancedConfigurations()}
                        </div>
                    </Tab>
                </Tabs>

                <ButtonToolbar className="schematicmap-button-toolbar">
                    <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>
                        Guardar
                    </Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>
                        Fechar
                    </Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={() => this.onExitMessage()}
                />
            </div>
        );
    }
}